import Link from "next/link"
import { useRouter } from "next/router"
import Arrow from "../../public/images/sidebar/sidebar_arrow.svg"
import { classNames } from "@today/lib"
import { URI_KEY } from "../../utils/const/uriKey.const"

type SidebarLogoProps = { isActiveSidebar: boolean; toggleSidebar: () => void }
function SidebarLogo({ isActiveSidebar, toggleSidebar }: SidebarLogoProps) {
  const router = useRouter()
  const orderState = router.query[URI_KEY.ORDERS_STATE]

  const ordersHref =
    typeof orderState === "string" && orderState
      ? `/orders?${URI_KEY.ORDERS_STATE}=${encodeURIComponent(orderState)}`
      : "/orders"

  return (
    <div className="flex h-16 w-full items-center justify-center px-4 py-4">
      <div className="flex items-center gap-x-2 text-xl font-semibold">
        {isActiveSidebar && (
          <Link href={ordersHref}>
            <span className="hidden sm:inline">Today </span>Partner
          </Link>
        )}
        <button onClick={toggleSidebar}>
          <Arrow
            className={classNames(
              `h-5 w-5 ${isActiveSidebar ? "rotate-180" : ""}`
            )}
          />
        </button>
      </div>
    </div>
  )
}

export default SidebarLogo
